<div class="department-details">

    <div *ngIf="department.value.id !== 0 || editMode" class="title-header">
        <div class="title-left">
            <span class="title-text">{{ departmentTitle | translate }}</span>
        </div>
        <div class="header-buttons" *ngIf="supervisor">
            <ng-container *ngIf="!editMode">
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deleteDepartment()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-container>
            <ng-container *ngIf="editMode">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveDepartment($event)"
                    icon="save">
                </action-button>
                <button class="btn-cancel" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">cancel</span>
                </button>
            </ng-container>
        </div>
    </div>

    <empty-details *ngIf="DepartmentEmpty()" what="empty.what.department"></empty-details>

    <div *ngIf="department.value.id !== 0 || editMode" class="department-info-container">

        <div *ngIf="department.value.id !== 0 && !editMode" class="department-info">
            <table>
                <tr class="info-row">
                    <td><strong class="label">{{ "departmentDetails.nameLabel" | translate }}</strong></td>
                    <td><span class="value">{{ department.value.name }}</span></td>
                </tr>
            </table>
            <messages
                class="message"
                [form]="departmentForm"
                [messagesObserver]="messages"
                fieldname="department"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="TRUE">
            </messages>
            <department-user [currentDepartmentId]="currentDepartmentId"></department-user>
        </div>

        <form [formGroup]="departmentForm" *ngIf="editMode" class="department-form">
            <div class="form-group">
                <label for="name">{{ "departmentDetails.nameLabel" | translate }}</label>
                <input type="text" id="name" formControlName="name" />
                <messages [form]="departmentForm" [messagesObserver]="messages" fieldname="name"></messages>
            </div>
            <messages
                class="message"
                [form]="departmentForm"
                [messagesObserver]="messages"
                fieldname="department"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="TRUE">
            </messages>
        </form>

    </div>
</div>
